import { Reveal, SectionHeading } from "./Reveal";

const TEAM = [
  {
    initials: "MM",
    name: "Matt Erikson C. Malagar",
    role: "Founder & CEO",
    desc: "Strategy, partnerships, and product vision. Entrepreneur and financial advisor with deep roots in Cebu's business and civic community.",
    placeholder: false,
  },
  {
    initials: "—",
    name: "[Name]",
    role: "Chief Technology Officer",
    desc: "Architecture and engineering of the LAIC platform — security, reliability, and performance.",
    placeholder: true,
  },
  {
    initials: "—",
    name: "[Name]",
    role: "Head of Operations & Implementation",
    desc: "Leads the two-month municipal onboarding: setup, configuration, and staff enablement.",
    placeholder: true,
  },
  {
    initials: "—",
    name: "[Name]",
    role: "Head of Government Relations",
    desc: "Works directly with mayors, treasurers, and department heads to fit LAIC to each LGU.",
    placeholder: true,
  },
];

export default function Team() {
  return (
    <section data-testid="team-section" className="relative border-t border-white/5 py-20 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <SectionHeading
          index="02"
          eyebrow="The Prime Movers"
          title={<>The people behind<br />the <span className="text-mac-accent">products</span>.</>}
          testId="team-heading"
        />

        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {TEAM.map((m, i) => (
            <Reveal key={m.role} delay={i * 0.1} className="bg-mac-base">
              <div className="card-tech h-full border-0" data-testid={`team-card-${i}`}>
                <span
                  className={`mb-6 grid h-14 w-14 place-items-center rounded-full font-display text-lg font-bold tracking-wider ${
                    m.placeholder
                      ? "border border-dashed border-white/25 text-slate-500"
                      : "border border-mac-accent/60 bg-mac-accent/10 text-mac-accent shadow-[0_0_24px_rgb(var(--mac-accent-rgb)/0.25)]"
                  }`}
                >
                  {m.initials}
                </span>
                <h3 className={`font-display text-xl font-semibold uppercase tracking-wider ${m.placeholder ? "text-slate-500" : "text-white"}`}>
                  {m.name}
                </h3>
                <p className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-mac-accent">{m.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{m.desc}</p>
                {m.placeholder && (
                  <p className="mt-3 font-mono text-[9px] uppercase tracking-[0.2em] text-slate-600">Profile to be announced</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
